import {Text} from "@blueprintjs/core";
import React from "react";

type Props = {
    totalCount?: number;
    startIndex?: number;
    endIndex?: number;
};

const PagerSummary = ({totalCount, startIndex, endIndex}: Props) => {
    if (!totalCount || !startIndex || !endIndex) {
        return null;
    }
    return (
        <Text className="bp4-text-muted" data-testid="page-summary">
            {`${totalCount}件中 ${startIndex}-${endIndex}`}
        </Text>
    );
};

export default PagerSummary;
